import { z } from 'zod';

/////////////////////////////////////////
// NOTIFICATION SCHEMA
/////////////////////////////////////////

export const NotificationSchema = z.object({
  id: z.bigint(),
  headline: z.string().nullable(),
  preview: z.string().nullable(),
  content: z.string().nullable(),
  author_id: z.string().nullable(),
  city_id: z.number().int(),
  published_at: z.coerce.date().nullable(),
  expired_at: z.coerce.date().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  last_notified_at: z.coerce.date().nullable(),
  subscription_groups_count: z.number().int().nullable(),
  is_draft: z.boolean().nullable(),
  channels: z.string().nullable(),
  classification_id: z.number().int().nullable(),
  voiceContent: z.string().nullable(),
  voiceForceSendAll: z.boolean().nullable(),
  voiceAudioResourceId: z.number().int().nullable(),
  defaultSocialMediaImageFileId: z.number().int().nullable(),
  restrict_to_geotarget_boundary: z.boolean().nullable(),
})

export type Notification = z.infer<typeof NotificationSchema>

export default NotificationSchema;
